<app-loader [isLoading]="isLoading"></app-loader>

<div class="header">
  <div class="top">
    <a [routerLink]="backLink">
      <h3>Tetris / Ejercicio {{ year }}/ {{ operativaGroup?.name }}</h3>
      <div class="breadcrumb">
        <mat-icon svgIcon="arrow back"></mat-icon>
        <h2>{{ isHolidaysMode ? 'Editar festivos' : 'Editar operativa' }}</h2>
      </div>
    </a>
  </div>
</div>

<div class="content form">
  <!-- HOLIDAYS MODE -->
  @if (isHolidaysMode) {
  <form>
    <h4>Festivos del grupo operativo</h4>
    <p class="subtitle">Los días festivos configurados no contarán como días de vacaciones para los conductores.</p>

    <!-- Add new holiday form -->
    <div class="holiday-form">
      <h5>Añadir nuevo festivo</h5>
      <div class="form-row full-width">
        <mat-form-field appearance="outline">
          <mat-label>Nombre del festivo</mat-label>
          <input matInput [(ngModel)]="newHoliday.name" [ngModelOptions]="{ standalone: true }"
            placeholder="Ej: Navidad, Semana Santa, etc." />
        </mat-form-field>
      </div>

      <div class="form-row holiday-row">
        <mat-form-field appearance="outline">
          <mat-label>Fecha de inicio</mat-label>
          <input matInput [matDatepicker]="startPicker" [(ngModel)]="newHoliday.start_date"
            [ngModelOptions]="{ standalone: true }" />
          <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Fecha de fin</mat-label>
          <input matInput [matDatepicker]="endPicker" [(ngModel)]="newHoliday.end_date"
            [ngModelOptions]="{ standalone: true }" />
          <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>
      </div>

      <button mat-flat-button id="action" type="button" (click)="addHoliday()">
        Añadir festivo
      </button>
    </div>

    <!-- Existing holidays table -->
    <h5>Festivos configurados</h5>
    <div class="table-container">
      <table mat-table [dataSource]="holidaysDataSource" class="mat-elevation-z8">
        <!-- Name Column -->
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>NOMBRE</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <!-- Start Date Column -->
        <ng-container matColumnDef="start_date">
          <th mat-header-cell *matHeaderCellDef>FECHA INICIO</th>
          <td mat-cell *matCellDef="let element">{{ formatDateDisplay(element.start_date) }}</td>
        </ng-container>

        <!-- End Date Column -->
        <ng-container matColumnDef="end_date">
          <th mat-header-cell *matHeaderCellDef>FECHA FIN</th>
          <td mat-cell *matCellDef="let element">{{ formatDateDisplay(element.end_date) }}</td>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="deleteHoliday(element)" class="delete-button">
              <mat-icon svgIcon="delete"></mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedHolidaysColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedHolidaysColumns"></tr>
      </table>

      @if (holidaysDataSource.data.length === 0) {
      <div class="no-data">
        <p>No hay festivos configurados</p>
      </div>
      }
    </div>

    <br><br>
    <div class="buttons">
      <button mat-flat-button id="cancel" type="button" (click)="cancel()">Volver</button>
    </div>
  </form>
  }

  <!-- PROTOCOLS MODE -->
  @else {
  <form>
    <h4>Configuración de operativas</h4>
    <p class="subtitle">Asigna un protocolo, tipo de días y configuración de vacaciones a cada tipología de cada
      operativa del grupo.</p>

    @if (isReadonly) {
    <div class="readonly-notice">
      <mat-icon>info</mat-icon>
      <span>El ejercicio ya ha comenzado. Los campos solo pueden visualizarse en modo lectura.</span>
    </div>
    }

    @if (operativaFormRows.length === 0) {
    <div class="no-data">
      <p>No hay operativas en este grupo</p>
    </div>
    } @else {
    <div class="operativas-list">
      @for (row of operativaFormRows; track row.id) {
      <div class="operativa-card">
        <h5 class="operativa-name">{{ row.name }}</h5>

        <!-- Tipology assignments -->
        @for (tipology of row.tipologyAssignments; track tipology.tipologyId) {
        <div class="tipology-section">
          <h6 class="tipology-name">{{ tipology.tipologyDisplay }}</h6>

          <div class="operativa-fields">
            <!-- Protocol Autocomplete -->
            <mat-form-field appearance="outline" class="field-protocol">
              <mat-label>Protocolo</mat-label>
              <input type="text" matInput placeholder="Buscar protocolo" [formControl]="tipology.protocolControl"
                [matAutocomplete]="autoProtocol" [readonly]="isReadonly">
              <mat-autocomplete #autoProtocol="matAutocomplete" [displayWith]="displayProtocolFn"
                (optionSelected)="onProtocolSelected(tipology, $event)">
                @for (protocol of tipology.filteredProtocols | async; track protocol.id) {
                <mat-option [value]="protocol">{{ protocol.name }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>

            <!-- Day Type Select -->
            <mat-form-field appearance="outline" class="field-day-type">
              <mat-label>Tipo de días</mat-label>
              <mat-select [(ngModel)]="tipology.selectedDayType" [ngModelOptions]="{ standalone: true }"
                [disabled]="isReadonly">
                @for (dayType of dayTypeOptions; track dayType.id) {
                <mat-option [value]="dayType.id">{{ dayType.name }}</mat-option>
                }
              </mat-select>
            </mat-form-field>

            <!-- Holidays Number -->
            <mat-form-field appearance="outline" class="field-holidays">
              <mat-label>Días vacaciones</mat-label>
              <input matInput type="number" [(ngModel)]="tipology.holidaysNumber"
                [ngModelOptions]="{ standalone: true }" min="0" [readonly]="isReadonly" />
            </mat-form-field>

            <!-- Personal Days Number -->
            <mat-form-field appearance="outline" class="field-personal">
              <mat-label>Días personales</mat-label>
              <input matInput type="number" [(ngModel)]="tipology.personalDaysNumber"
                [ngModelOptions]="{ standalone: true }" min="0" [readonly]="isReadonly" />
            </mat-form-field>
          </div>
        </div>
        }
      </div>
      }
    </div>
    }

    <br><br>
    <div class="buttons">
      @if (!isReadonly) {
      <button mat-flat-button id="action" type="button" (click)="saveChanges()" [disabled]="isSubmitting">
        @if (isSubmitting) {
        Actualizando...
        } @else {
        Actualizar
        }
      </button>
      }
      <button mat-flat-button id="cancel" type="button" (click)="cancel()">{{ isReadonly ? 'Volver' : 'Cancelar'
        }}</button>
    </div>
  </form>
  }
</div>